export const state = {
  checked: false,
  userType: null,
  submitForm: {
    type: null,
    files: []
  },
  assignorMobile: '',
  mobile: '',
  accName: '',
  companyLegalInfo: {},
  isLegal: false, // 授权人是否是法人
  personMobile: '' // 个人手机号
};
